// 把「不含 storage prefix 的 storageKey」与 storage.prefix 拼成对象存储里的实际 object key。
// 仅用于对象存储（minio / cos）：NAS 的 prefix 由 local-server 自行拼接（resolveNasFullPath），
// 不要对 NAS key 用本函数，否则会重复前置 prefix。
//   - prefix 去首尾斜杠后前置；
//   - storageKey 可带或不带前导斜杠，统一为单斜杠分隔（上传路径 buildOssShapePath 带前导 /，
//     转码反推的 storageKey 不带）；
//   - prefix 为空（如未配租户根）→ 原样返回 storageKey（保持其前导斜杠，与历史 presign 行为一致）。
export const buildStorageObjectKey = (
  prefix: string | null | undefined,
  storageKey: string,
  filename?: string,
): string => {
  const cleanPrefix = prefix?.replace(/^\/+|\/+$/g, '') ?? ''
  const base = cleanPrefix ? `${cleanPrefix}${storageKey.startsWith('/') ? '' : '/'}${storageKey}` : storageKey
  return filename ? `${base}/${filename}` : base
}

// 从「对象 key / 反推出的 storageKey」剥掉 storage.prefix，得到不含 prefix 的 storageKey（落库用）。
// 与 buildStorageObjectKey 互逆：strip 后再以同一 prefix build 即还原原始对象 key。
//   prefix 为空则原样返回。
export const stripStoragePrefix = (key: string, prefix: string | null | undefined): string => {
  const cleanPrefix = prefix?.replace(/^\/+|\/+$/g, '') ?? ''
  if (!cleanPrefix) return key
  if (key === cleanPrefix) return ''
  // 保留分隔斜杠，使结果与 buildOssShapePath 一样带前导 /（再 build 时单斜杠分隔）。
  if (key.startsWith(`${cleanPrefix}/`)) return key.slice(cleanPrefix.length)
  return key
}
